import SportsHandballIcon from '@mui/icons-material/SportsHandball';
import SportsVolleyballIcon from '@mui/icons-material/SportsVolleyball';
import { Box, Typography } from '@mui/material';

export function ExplainingIcons() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: 2,
        bgcolor: '#fdd8e4',
        py: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          alignItems: 'center',
        }}
      >
        <SportsHandballIcon sx={{ color: 'primary.main' }} />
        <Typography variant="h6">Atacante</Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          alignItems: 'center',
        }}
      >
        <SportsVolleyballIcon sx={{ color: 'red' }} />
        <Typography variant="h6">Levantador</Typography>
      </Box>
      <Box>
        <Typography variant="h6">Sem ícone: Sem preferência</Typography>
        <br />
      </Box>
    </Box>
  );
}
